import React from 'react'

export const CardActivationIcon = () => (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="credit-card"
    className="svg-inline--fa fa-credit-card"
    role="img"
    style={{ width: '21.5px' }}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
  >
    <path
      fill="currentColor"
      d="M0 96C0 78.3 14.3 64 32 64H544c17.7 0 32 14.3 32 32V128H0V96zM0 160H576V416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V160zm64 96a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm64 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32z"
    />
  </svg>
)

export const Cart = () => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.1875 2.5H3.94531C4.80469 2.5 5.58594 3.00781 5.9375 3.75H21.9922C23.0078 3.75 23.75 4.72656 23.4766 5.74219L21.875 11.6797C21.5625 12.9297 20.4297 13.75 19.1797 13.75H7.89062L8.125 14.8828C8.20312 15.3125 8.59375 15.625 9.02344 15.625H20.3125C20.8203 15.625 21.25 16.0547 21.25 16.5625C21.25 17.1094 20.8203 17.5 20.3125 17.5H9.02344C7.69531 17.5 6.52344 16.5625 6.28906 15.2344L4.25781 4.64844C4.21875 4.49219 4.10156 4.375 3.94531 4.375H2.1875C1.64062 4.375 1.25 3.98438 1.25 3.4375C1.25 2.92969 1.64062 2.5 2.1875 2.5ZM6.36719 5.625L7.53906 11.875H19.1797C19.6094 11.875 19.9609 11.6016 20.0781 11.2109L21.5625 5.625H6.36719ZM8.125 22.5C7.42188 22.5 6.83594 22.1484 6.48438 21.5625C6.13281 21.0156 6.13281 20.2734 6.48438 19.6875C6.83594 19.1406 7.42188 18.75 8.125 18.75C8.78906 18.75 9.375 19.1406 9.72656 19.6875C10.0781 20.2734 10.0781 21.0156 9.72656 21.5625C9.375 22.1484 8.78906 22.5 8.125 22.5ZM21.25 20.625C21.25 21.3281 20.8594 21.9141 20.3125 22.2656C19.7266 22.6172 18.9844 22.6172 18.4375 22.2656C17.8516 21.9141 17.5 21.3281 17.5 20.625C17.5 19.9609 17.8516 19.375 18.4375 19.0234C18.9844 18.6719 19.7266 18.6719 20.3125 19.0234C20.8594 19.375 21.25 19.9609 21.25 20.625Z"
      fill="black"
    />
  </svg>
)
export const CheckGreen = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.2812 5.21875C17.5625 5.53125 17.5625 6 17.2812 6.28125L9.03125 14.5312C8.71875 14.8438 8.25 14.8438 7.96875 14.5312L3.71875 10.2812C3.40625 10 3.40625 9.53125 3.71875 9.25C4 8.9375 4.46875 8.9375 4.75 9.25L8.46875 12.9688L16.2188 5.21875C16.5 4.9375 16.9688 4.9375 17.25 5.21875H17.2812Z"
      fill="#3AD399"
    />
  </svg>
)

export const XRed = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.2812 6.28125L11.5312 10.0312L15.25 13.75C15.5625 14.0312 15.5625 14.5 15.25 14.7812C14.9688 15.0938 14.5 15.0938 14.2188 14.7812L10.4688 11.0625L6.75 14.7812C6.46875 15.0938 6 15.0938 5.71875 14.7812C5.40625 14.5 5.40625 14.0312 5.71875 13.7188L9.4375 10L5.71875 6.28125C5.40625 6 5.40625 5.53125 5.71875 5.21875C6 4.9375 6.46875 4.9375 6.78125 5.21875L10.5 8.96875L14.2188 5.25C14.5 4.9375 14.9688 4.9375 15.2812 5.25C15.5625 5.53125 15.5625 6 15.2812 6.28125Z"
      fill="#F35B69"
    />
  </svg>
)
export const ChevronUp = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.5313 5.46875L16.5312 11.4688C16.8438 11.75 16.8438 12.2188 16.5312 12.5312C16.25 12.8125 15.7812 12.8125 15.4688 12.5312L10 7.03125L4.53125 12.5C4.25 12.8125 3.78125 12.8125 3.46875 12.5C3.1875 12.2187 3.1875 11.75 3.46875 11.4687L9.5 5.46875C9.78125 5.15625 10.25 5.15625 10.5313 5.46875Z"
      fill="black"
    />
  </svg>
)

export const ChevronDown = () => (
  <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.46875 7.53125L0.46875 1.53125C0.15625 1.25 0.15625 0.78125 0.46875 0.46875C0.75 0.1875 1.21875 0.1875 1.53125 0.46875L7 5.96875L12.4688 0.5C12.75 0.1875 13.2188 0.1875 13.5312 0.5C13.8125 0.78125 13.8125 1.25 13.5312 1.53125L7.5 7.53125C7.21875 7.84375 6.75 7.84375 6.46875 7.53125Z"
      fill="black"
    />
  </svg>
)

export const MoreInfo = () => (
  <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 12C4.84375 12 2.875 10.875 1.79688 9C0.71875 7.14844 0.71875 4.875 1.79688 3C2.875 1.14844 4.84375 0 7 0C9.13281 0 11.1016 1.14844 12.1797 3C13.2578 4.875 13.2578 7.14844 12.1797 9C11.1016 10.875 9.13281 12 7 12ZM6.0625 7.875C5.73438 7.875 5.5 8.13281 5.5 8.4375C5.5 8.76562 5.73438 9 6.0625 9H7.9375C8.24219 9 8.5 8.76562 8.5 8.4375C8.5 8.13281 8.24219 7.875 7.9375 7.875H7.75V5.8125C7.75 5.50781 7.49219 5.25 7.1875 5.25H6.0625C5.73438 5.25 5.5 5.50781 5.5 5.8125C5.5 6.14062 5.73438 6.375 6.0625 6.375H6.625V7.875H6.0625ZM7 3C6.57812 3 6.25 3.35156 6.25 3.75C6.25 4.17188 6.57812 4.5 7 4.5C7.39844 4.5 7.75 4.17188 7.75 3.75C7.75 3.35156 7.39844 3 7 3Z"
      fill="black"
    />
  </svg>
)
